'use client';

import Link from 'next/link';

import { homepageFaqs as faqs } from '@/content/chatCoFaqs';
import PageLink from '@/utils/PageLink';

const FaqCompact: React.FC = () => {
  return (
    <section aria-label="Frequently asked questions" className="bg-white py-16 sm:py-20" id="faq">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Questions?{' '}
            <span className="font-display font-medium italic text-primary-600">Answered.</span>
          </h2>
          <p className="mt-4 text-lg text-gray-500">
            Everything you need to know before you start.
          </p>
        </div>

        <div className="mt-10 divide-y divide-gray-100 rounded-[28px] border border-gray-100 bg-white px-6 shadow-sm sm:px-8">
          {faqs.map((faq, index) => (
            <details key={faq.id} className="py-5" open={index === 0}>
              <summary className="cursor-pointer text-base font-semibold text-gray-900">
                {faq.question}
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-gray-600">{faq.answer}</p>
            </details>
          ))}
        </div>

        <p className="mt-8 text-center text-sm text-gray-500">
          Still have questions?{' '}
          <Link
            href={PageLink.demo}
            className="font-medium text-primary-600 hover:text-primary-700">
            Book a demo
          </Link>{' '}
          and we&apos;ll walk you through your use case.
        </p>
      </div>
    </section>
  );
};

export default FaqCompact;
